import * as React from "react";
import EmailResponseForm from "./EmailResponseForm";
import Login from "../../shared/components/Login";
import {
  makeStyles,
  Spinner,
  Text,
  Button,
  tokens,
} from "@fluentui/react-components";
import { SignOutRegular } from "@fluentui/react-icons";
import { insertText } from "../taskpane";
import { useAuth } from "../../shared/contexts/AuthContext";

interface AppProps {
  title: string;
}

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#e7eeff",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "12px 16px",
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  title: {
    fontSize: "16px",
    fontWeight: "600",
    color: tokens.colorNeutralForeground1,
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    padding: "40px",
  },
});

const App: React.FC<AppProps> = ({ title }) => {
  const styles = useStyles();
  const { isAuthenticated, isLoading, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <div className={styles.root}>
      {isAuthenticated && (
        <div className={styles.header}>
          <Text className={styles.title}>{title}</Text>
          <Button
            appearance="subtle"
            icon={<SignOutRegular />}
            onClick={handleLogout}
            size="small"
          >
            Logout
          </Button>
        </div>
      )}

      <div className={styles.content}>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <Spinner size="large" />
            <Text>Authenticating with Keycloak...</Text>
          </div>
        ) : isAuthenticated ? (
          <EmailResponseForm insertText={insertText} />
        ) : (
          <Login />
        )}
      </div>
    </div>
  );
};

export default App;
